import { render, staticRenderFns } from "./button-icon.vue?vue&type=template&id=77ab4455"
import script from "./button-icon.vue?vue&type=script&lang=js"
export * from "./button-icon.vue?vue&type=script&lang=js"
import style0 from "./button-icon.vue?vue&type=style&index=0&id=77ab4455&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports